import React from "react"
import styled, { css } from "styled-components"
import { up } from "styled-breakpoints"
import colors from "@constants/colors"
import { h5 } from "@constants/typography"
import LinkButton from "@components/buttons/LinkButton"
import BackgroundImage, {
  Container as BackgroundImageContainer,
} from "@components/BackgroundImage"
import { DatoResponsiveImage } from "@dato/types"
import { columns } from "@constants/layout"

const Container = styled.div`
  width: 100%;

  ${BackgroundImageContainer} {
    aspect-ratio: 1 / 2;
    padding: 80px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 300px;
  }

  ${up("tablet")} {
    ${BackgroundImageContainer} {
      aspect-ratio: 16 / 6;
      padding: 40px;
    }
  }
`

const Heading = styled.h4<{ halfWidth?: boolean }>`
  ${({ halfWidth }) => css`
    ${h5}
    margin: 0;
    text-align: center;
    color: ${colors.snow};

    ${up("laptop")} {
      padding: 0 ${halfWidth ? columns(2) : columns(4)};
      font-size: 28px;
      line-height: 36px;
    }
  `}
`

export interface BaseCTABlockProps {
  headline: string
  url?: string
  buttonText: string
  backgroundImage: DatoResponsiveImage
  mobileBackgroundImage?: DatoResponsiveImage
  style?: React.CSSProperties
  buttonColor?: string
  buttonTextColor?: string
}

interface ExtendedProps extends BaseCTABlockProps {
  halfWidth?: boolean
}
const CTABlock: React.FC<ExtendedProps> = ({
  headline,
  url,
  buttonText,
  backgroundImage,
  mobileBackgroundImage,
  halfWidth,
  style,
  buttonColor,
  buttonTextColor,
}) => {
  // console.log("testt", mobileBackgroundImage)
  return (
    <Container style={style}>
      <BackgroundImage
        image={backgroundImage}
        mobileImage={mobileBackgroundImage}
      >
        <Heading halfWidth={halfWidth}>{headline}</Heading>
        {url && (
          <LinkButton
            href={url}
            buttonColor={buttonColor}
            buttonTextColor={buttonTextColor}
          >
            {buttonText}
          </LinkButton>
        )}
      </BackgroundImage>
    </Container>
  )
}

export default CTABlock
